'use client';

import { useEffect } from 'react';
import { usePathname } from 'next/navigation';

import MOBILE_CHECKOUT_QUERY from '@/joystagram-components/components/consumer/checkout/desktop/mobileCheckoutQuery';
import ensurePostHogClientInitialized from './ensurePostHogClientInitialized';
import getClientShouldUseCookielessMode from './getClientShouldUseCookielessMode';
import handlePostHogInitError from './handlePostHogInitError';

// The checkout A/B test gives up after 2s, long before PostHogDeferredInit runs
const PostHogMobileCheckoutInit = () => {
  const pathname = usePathname();

  useEffect(() => {
    if (
      !pathname?.startsWith('/checkout') ||
      !window.matchMedia(MOBILE_CHECKOUT_QUERY).matches
    ) {
      return;
    }

    ensurePostHogClientInitialized({
      shouldUseCookielessMode: getClientShouldUseCookielessMode(),
    }).catch(handlePostHogInitError);
  }, [pathname]);

  return null;
};

export default PostHogMobileCheckoutInit;
